import "./index.css";
import { OrganiserIcon, GearIcon, PrinterIcon } from "../../icons";

/** The pharmacy label bar: wordmark, prescription line (children), tools. */
function Header({ children, onOpenSettings, onPrint }) {
  return (
    <header className="LabelBar screen-only">
      <div className="LabelBar-brand">
        <OrganiserIcon className="LabelBar-mark" width="26" height="26" />
        <span className="LabelBar-wordmark">Schedule Keeper</span>
      </div>
      <div className="LabelBar-rx">{children}</div>
      <div className="LabelBar-tools">
        <button type="button" className="ToolButton" onClick={onOpenSettings} aria-label="Settings" title="Settings">
          <GearIcon />
        </button>
        <button type="button" className="ToolButton" onClick={onPrint} aria-label="Print" title="Print">
          <PrinterIcon />
        </button>
      </div>
    </header>
  );
}

export default Header;
